import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidenav from './components/common/Sidenav';
import ProtectedRoute from './components/common/ProtectedRoute';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import OnboardingForm from './pages/HotelOnboarding/OnboardingForm';
import ShowOnboardingHotel from './pages/HotelOnboarding/ShowOnboardingHotel';
import RoomManagement from './pages/RoomManagement/RoomManagement';
import ProfileCard from './pages/profilecard/profileCard';
import './App.css';
import logo from './assets/Images/ll3.png';

function App() {
  return (
    <Router>
      <div className="app">
        <Sidenav />
        <main className="main-content">
          <div className="top-bar">
            <img src={logo} alt="Logo" className="top-bar-logo" />
          </div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hotel-onboarding"
              element={
                <ProtectedRoute>
                  <OnboardingForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Showhotelonboarding"
              element={
                <ProtectedRoute>
                  <ShowOnboardingHotel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/room-management"
              element={
                <ProtectedRoute>
                  <RoomManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfileCard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
